<template>
  <v-list-item @click="open">
    <v-list-item-avatar>
      <v-icon small>fal fa-people-carry</v-icon>
    </v-list-item-avatar>
    <v-list-item-content>担当者の変更</v-list-item-content>
    <v-dialog class="author-toolkit" v-model="config.status.active" max-width="600px">
      <v-card>
        <v-card-title class="primary amber blue-grey--text text--darken-4">
          <span class="headline">担当者の変更</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-row dense>
              <v-col cols="12">
                <v-text-field readonly
                  label="変更前"
                  v-model="form.author.from"
                />
              </v-col>
              <v-col cols="12">
                <v-select
                  v-model="form.author.to"
                  label="変更後"
                  item-text="name"
                  item-value="userid"
                  :items="getConsultantItems"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn text color="secondary" @click="close">閉じる</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="secondary white--text" depressed :disabled="!isSubmittable" :loading="isInitializaing || isLoading" @click="submit">保存する</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-list-item>
</template>

<script>
export default {
  name: 'author-toolkit',
  data () {
    return {
      config: {
        status: {
          active: false,
          initializing: false,
          loading: false
        }
      },
      meta: {
        authors: []
      },
      form: {
        author: {
          from: '',
          to: ''
        }
      },
      store: {
        authors: []
      }
    }
  },
  methods: {
    open: function () {
      let authors = this.$store.getters['config/get']('authors')
      let aid = this.$store.getters['client/get']('author')

      this.$set(this.config.status, 'active', true)
      this.$set(this.form, 'author', {
        from: authors[aid] ? authors[aid].name[0] : '',
        to: authors[aid] ? authors[aid].userid : ''
      })
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
      this.$emit('close')
    },
    submit: function () {
      this.$set(this.config.status, 'loading', true)
      this.$firebase.auth().currentUser.getIdToken(true).then(token => {
        this.axios.post(`${this.$url.api}client/update/author`, {
          id: this.$route.params.id,
          aid: this.form.author.to
        }, {
          headers: {
            'firebase-token': token
          }
        }).then(res => {
          console.log(res)
          if (res.data && res.data.success) {
            this.$store.commit('client/update', {
              author: this.form.author.to
            })
            this.close()
          }
          this.$set(this.config.status, 'loading', false)
        })
      })
    }
  },
  computed: {
    getConsultantItems () {
      let authors = this.$store.getters['config/get']('authors')
      return Object.keys(authors).filter(userid => {
        return authors[userid].roles.includes('consultant')
      }).map(userid => {
        return {
          userid,
          name: authors[userid].name[0]
        }
      })
    },
    isSubmittable () {
      return this.$store.getters['client/get']('author').id !== this.form.author.to
    },
    isInitializaing () {
      return this.config.status.initializing
    },
    isLoading () {
      return this.config.status.loading
    }
  }
}
</script>

<style lang="scss">
.author-toolkit {
  .app {
    position: relative;
    .label {
      position: absolute;
      bottom: -2em;
      left: 0;
      display: block;
    }
  }
}
</style>
